import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import {getCurrentSecond, isOpenNow} from "./logic";
import PhoneHoursDisplay from "./PhoneHoursDisplay";

const isDev = (process.env.NODE_ENV == 'development');

// update every 30 seconds (less in dev)
const INTERVAL = isDev ? 1000 : 30_000;

export default function PhoneHoursApp({
  phoneNumber,
  caption = '7 days/week',
  phoneStatus = {}
}) {
  const [localStartSecond, ] = useState(getCurrentSecond); // no setter

  const [currentSecond, setCurrentSecond] = useState(getCurrentSecond);

  useEffect(() => {
    // update our state every 30s.
    window.setInterval(() => {
      // getCurrentSection is a function that returns an integer.
      setCurrentSecond(getCurrentSecond);
    }, INTERVAL)
  }, []);

  // compare time of day with the posted open/close
  const openNow = isOpenNow({
    ...phoneStatus,
    elapsed: (currentSecond - localStartSecond)
  });

  return <PhoneHoursDisplay
    phoneNumber={phoneNumber}
    caption={caption}
    openNow={openNow} />
}

PhoneHoursApp.propTypes = {
  phoneStatus: PropTypes.shape({
    // "Second" is seconds since midnight in the server's zone
    startupSecond: PropTypes.number,
    openSecond: PropTypes.number,
    closeSecond: PropTypes.number,
    openNow: PropTypes.bool
  }).isRequired
}
